var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submission"},[_c('error',{attrs:{"err":_vm.error}}),_c('form-generator',{attrs:{"data":_vm.book,"elements":_vm.elements,"handleUpdate":_vm.handleUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }